import { formatGerman } from '@/src/components/core/lib/date'
import FacetFilter from '@/src/components/flch/components/filter/FacetFilter'
import { Facet } from '@/src/components/flch/components/filter/types'
import {
  Course,
  courseMonthLabel,
  courseStartDate,
  courseWeekdayLabel,
  formatAddress,
  WEEKDAY_ORDER,
} from '@/src/components/flch/courseLocation/lib'

const FACETS: Facet<Course>[] = [
  {
    name: 'Kurslokal',
    labels: (course) => [formatAddress(course.course.address)],
    options: (courses) =>
      [
        ...new Set(
          courses.map((course) => formatAddress(course.course.address))
        ),
      ].sort((a, b) => a.localeCompare(b, 'de')),
  },
  {
    name: 'Wochentag',
    labels: (course) => [courseWeekdayLabel(course.course)],
    options: (courses) =>
      [
        ...new Set(courses.map((course) => courseWeekdayLabel(course.course))),
      ].sort(
        (a, b) =>
          WEEKDAY_ORDER.indexOf(a.split(' & ')[0]) -
          WEEKDAY_ORDER.indexOf(b.split(' & ')[0])
      ),
  },
  {
    name: 'Monat',
    labels: (course) => [courseMonthLabel(course.course)],
    options: (courses) => {
      const byLabel = new Map<string, string>()
      for (const course of courses) {
        byLabel.set(
          courseMonthLabel(course.course),
          formatGerman(courseStartDate(course.course), 'yyyy-MM')
        )
      }
      return [...byLabel.entries()]
        .sort(([, a], [, b]) => a.localeCompare(b))
        .map(([label]) => label)
    },
  },
  {
    name: 'Preis',
    labels: (course) => [`${course.course.price / 100} CHF`],
    options: (courses) =>
      [
        ...new Set(courses.map((course) => `${course.course.price / 100} CHF`)),
      ].sort((a, b) => parseInt(a, 10) - parseInt(b, 10)),
  },
]

const Filter = ({
  courses,
  setFilteredCourses,
}: {
  courses: Course[]
  setFilteredCourses: (courses: Course[]) => void
}) => (
  <FacetFilter
    items={courses}
    facets={FACETS}
    breakpoint="md"
    resultLabel={(count) =>
      `${count} ${count === 1 ? 'Kurs' : 'Kurse'} anzeigen`
    }
    onFilteredChange={setFilteredCourses}
  />
)

export default Filter
